import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { config } from '@/config';
import { resetPostHog } from '@/core/analytics';

export const Logout = () => {
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const handleLogout = () => {
    resetPostHog();
    fetch(config.base.baseUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ query: 'mutation Logout {logout}' }),
    })
      .then((res) => res.json())
      .then((data) => {
        window.location.href = '/login';
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    handleLogout();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '16px',
      }}
    >
      <Spin indicator={antIcon} size='large' />
      <div style={{ fontSize: '16px', color: '#666' }}>Logout...</div>
    </div>
  );
};
